import React from 'react';

import _ from 'lodash';
import { firebaseRoot } from './../utils/firebase-utils';
import ReactFireMixin from 'reactfire';
import { Router, Route, Link } from 'react-router';

import MobileHeader from '../components/MobileHeader/MobileHeader';
import TouchLink from '../components/TouchLink';

import ChapterItem from '../components/ChapterItem/ChapterItem';
import SubchapterItem from '../components/SubchapterItem/SubchapterItem';

const LessonSubChapters = React.createClass({
	mixins: [ReactFireMixin],

    contextTypes: {
        history: React.PropTypes.object.isRequired
    },

	getInitialState: function () {
		return {
			book: null,
			chapter: null,
			subChapters: null,
			exercises: null,
            progress: 0,
            progressLabel: ''
		};
	},

	componentWillMount: function () {
		this.bindAsObject(firebaseRoot.child('content/books').child(this.props.params.bookId), "book");
		this.bindAsObject(firebaseRoot.child('content/chapters').child(this.props.params.bookId).child(this.props.params.chapterId), "chapter");
		this.bindAsArray(firebaseRoot.child('content/subchapters').child(this.props.params.bookId).child(this.props.params.chapterId), "subChapters");
        this.chapterUnderExercisesRef = firebaseRoot.child('content/exercises').child(this.props.params.bookId).child(this.props.params.chapterId);
	},

	render() {
		if (!this.areAllBindingsLoaded()) {
			return <div>Loading...</div>;
		}
		return(
			<div className="screen-wrap">
				<MobileHeader
					lessonId={this.props.params.lessonId}
					problemId={this.props.params.problemId}
					bookId={this.props.params.bookId}
					type='default'
					title='Ta en lektion'
					// Don't show the back button on the root screen.
					backButton={this.props.location.pathname.length > 1}
				/>
				<div className="screen-content">
					<ol className="chapters-list">

						<ChapterItem
							element="li"
							label={`${this.state.chapter.name} - 33%`}
							progressbar="33"
						>
							<ol className="subchapters-list">
								{
									_.map(this.state.subChapters, (subchapter, subchapterKey) => {
										if (subchapterKey == '.key') {
											return null;
										}
										// TODO: Fix link to specific exercise and also state on the subchapter: complete & started & pristine(?)
										let firstExerciseId = subchapter.firstExercise;
                                        let subChapterKey = subchapter['.key'];

										return (
											<SubchapterItem
                                                to=""
                                                key={subchapter['.key']}
                                                subChapterKey={subchapter['.key']}
                                                firstExerciseId={firstExerciseId}
                                                handleClicked={this.getLessonIdFormExercises}
												state="pristine"
												label={subchapter.name}
                                                progress={this.state.progress}
                                                progressLabel={subchapterKey + 1}
											/>
										);
									})
								}
							</ol>
						</ChapterItem>
					</ol>
				</div>
			</div>
		);
	},

    getLessonIdFormExercises(subChapterKey, firstExerciseId) {
        this.chapterUnderExercisesRef.child(subChapterKey).child(firstExerciseId).once("value", (snapshot) => {
            var data = snapshot.val();
            this.context.history.push(`/lesson/${data.lesson}`);
        });
    }
});

export default LessonSubChapters;



/** WEBPACK FOOTER **
 ** ./src/screens/LessonSubChapters.js
 **/